export default __webpack_public_path__ + "static/media/logo.5be4230a.png";